import { ComponentPropsWithoutRef, FC } from 'react';
import { IonToolbar } from '@ionic/react';
import StartIcon from '../../assets/icons/StartIcon';
import classnames from 'classnames';
import useAppMethods from '../../../../hooks/utility/useAppMethods';
import useCashbackProgram from '../../../../hooks/cashback/useCashbackProgram';
import { Routes } from '../../exports/Enums';
import useRouter from '../../../../hooks/navigation/useRouter';
import { useTranslation } from 'react-i18next';

type RewardsToolbarProps = ComponentPropsWithoutRef<typeof IonToolbar>;

const RewardsToolbar: FC<RewardsToolbarProps> = ({ className, ...rest }): JSX.Element => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Rewards:RewardsToolbar' });
  const { navigate } = useRouter();
  const { formatCurrency } = useAppMethods();
  const { balance, formattedBalance } = useCashbackProgram();
  const pointsAsMoney = formattedBalance ?? formatCurrency(0);

  return (
    <>
      <IonToolbar
        className={classnames(
          'ion-color h-fit bg-white !p-0 min-w-[300px] px-sm w-fit mx-auto rounded-[10px] [&::part(container)]:p-none shadow-section',
          className,
        )}
        {...rest}
      >
        <div
          className="h-fit my-0 px-[4px] !pt-none pb-[4px]"
          onClick={() =>
            navigate({
              mobile: {
                path: Routes.Rewards,
              },
            })
          }
        >
          <div className="text-brand-text-primary w-full">
            <div className="flex justify-center items-center px-sm py-md">
              <h4 className="font-semibold text-center">{t('title')}</h4>
            </div>
            <div className="flex flex-row justify-center">
              <div className="w-full border-t p-xs border-mobile-notice border-r flex flex-col items-center">
                <p className="font-semibold text-[20px]">{pointsAsMoney}</p>
                <small className="text-xs font-medium text-brand-text-secondary">{t('store_credit')}</small>
              </div>
              <div className="w-full border-t p-xs border-mobile-notice flex flex-col items-center">
                <p className="font-semibold text-[20px] flex items-center justify-center">
                  {balance}
                  <span className="ml-1">
                    <StartIcon className="size-4 fill-brand-primary" />
                  </span>
                </p>
                <small className="text-xs font-medium text-brand-text-secondary">{t('points_balance')}</small>
              </div>
            </div>
          </div>
        </div>
      </IonToolbar>
    </>
  );
};

export default RewardsToolbar;
